import { render, staticRenderFns } from "./ModalFeedback.vue?vue&type=template&id=1efb1464&scoped=true&"
import script from "./ModalFeedback.vue?vue&type=script&lang=js&"
export * from "./ModalFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ModalFeedback.vue?vue&type=style&index=0&id=1efb1464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efb1464",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1efb1464')) {
      api.createRecord('1efb1464', component.options)
    } else {
      api.reload('1efb1464', component.options)
    }
    module.hot.accept("./ModalFeedback.vue?vue&type=template&id=1efb1464&scoped=true&", function () {
      api.rerender('1efb1464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/ModalFeedback.vue"
export default component.exports